var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',[_c('div',{staticClass:"carditem"},_vm._l((_vm.noticeList),function(item){return _c('div',{key:item.index,staticClass:"title"},[_c('i',{staticClass:"el-icon-caret-right"}),_c('p',{on:{"click":function($event){return _vm.godetails(item.id, item.year, item.quarter)}}},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }